

Mindbreeze.define('plugins',[], function () {
  return {}
});